import React from 'react';
import TextField from '@material-ui/core/TextField';
import NumberFormat from 'react-number-format';
import styled from 'styled-components';
import { Formik } from 'formik';
import { PrimaryButton } from '../../../components/Buttons';

import FlatButton from '../../../components/Buttons/FlatButton';
import appConfig from '../../../../app-config';
import AboutPin from '../LoyaltyRegisteration/AboutPin';

const Wrapper = styled.div`
  padding-bottom: 40px;
`;
const LogoWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
`;
const Logo = styled.img`
  height: 350;
  @media (max-width: 786px) {
    order: -1;
  }
`;
const MessageWrapper = styled.div`
  padding: 0 16px;
  margin-bottom: 15px;
  text-align: center;
`;
const LinkCard = styled(PrimaryButton)`
  padding: 19px 16px 19px 24px;
  font-size: 19px;
  font-weight: 600;
  text-transform: uppercase;
  &:hover {
    transition: all 0.25s ease;
  }
`;
const FieldWrapper = styled.div`
  margin-bottom: 10px;
`;
const SecButton = styled(FlatButton)`
  padding: 8px 16px;
  font-size: 19px;
  font-weight: 600;
  text-transform: uppercase;
  margin-top: 20px;
  border: 1px solid #000;
  border-radius: 5px;
  min-width: 280px;
  &:hover {
    transition: all 0.25s ease;
  }
`;
const SkipButton = styled(FlatButton)`
  color: ${(props) => props.theme.skipForNowButton || props.theme.bodyColor};
  padding: 8px 16px;
  font-size: 19px;
  font-weight: 600;
  margin-top: 20px;
  &:hover {
    transition: all 0.25s ease;
  }
`;

const ActionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
`;

const initialLoyaltyCardValues = { loyalty_number: null, pin: null };

export const LoyaltyTransferBalanceForm = ({ handleNavigateToSubmit }) => {
  return (
    <Wrapper>
      <LogoWrapper>
        <Logo src={appConfig.styleConfig.loyaltyCardImage} />
      </LogoWrapper>
      <MessageWrapper>
        Enter your Burrito Boyz Gift Card details to transfer the balance to
        your existing account. You’ll need your gift card number and PIN, which
        can be found on the back of your physical card.
      </MessageWrapper>
      <Formik
        initialValues={initialLoyaltyCardValues}
        validate={(values) => {
          let errors = {};
          if (!values.loyalty_number) {
            errors.loyalty_number = 'Required';
          }
          if (!values.pin) {
            errors.pin = 'Required';
          }
          return errors;
        }}
        onSubmit={(values) => handleNavigateToSubmit(values)}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          dirty,
          isValid,
          setFieldValue,
          handleSubmit,
        }) => (
          <form onSubmit={handleSubmit}>
            <FieldWrapper>
              <NumberFormat
                id='ExistingGiftCard-CardNumber'
                label='Loyalty card number'
                name='loyalty_number'
                value={values.loyalty_number}
                onChange={(e) =>
                  setFieldValue('loyalty_number', e.target.value?.trim())
                }
                customInput={TextField}
                onBlur={handleBlur}
                error={
                  touched.loyalty_number && errors.loyalty_number ? true : false
                }
                helperText={
                  touched.loyalty_number && errors.loyalty_number
                    ? 'Required'
                    : ''
                }
                style={{ width: '100%' }}
                required
              />
            </FieldWrapper>
            <FieldWrapper>
              <NumberFormat
                id='ExistingGiftCard-Pin'
                label='PIN'
                name='pin'
                value={values.pin}
                onChange={(e) => setFieldValue('pin', e.target.value)}
                customInput={TextField}
                onBlur={handleBlur}
                style={{ width: '100%' }}
                error={touched.pin && errors.pin ? true : false}
                helperText={touched.pin && errors.pin}
                required
              />
            </FieldWrapper>
            <FieldWrapper>
              <AboutPin />
            </FieldWrapper>

            <ActionWrapper>
              <LinkCard
                id='ExistingGiftCard-AddGiftCard'
                type='submit'
                disabled={!dirty || !isValid}
              >
                Continue
              </LinkCard>
            </ActionWrapper>
          </form>
        )}
      </Formik>
    </Wrapper>
  );
};
